import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConstantsStore} from './constants.store';
import {Observable} from 'rxjs';
import {UserConsentsStatus} from '../../models/user-consents/user-consents-status';

@Injectable({
  providedIn: 'root'
})
export class UserConsentsService {

  constructor(
    private http: HttpClient,
    private urls: ConstantsStore) { }

  getStatus(): Observable<UserConsentsStatus> {
    return this.http.get<UserConsentsStatus>(this.urls.userConsentsUrl);
  }

  addConsent(consent: {privacy?: boolean; terms?: boolean}) {
    return this.http.post(this.urls.userConsentsUrl, consent);
  }
}
